import { apiClient, type ApiOpts } from './client';

export type BusinessDateResponse = {
  business_date?: string;
  businessDate?: string;
  system_timestamp?: string;
  systemTimestamp?: string;
};

export type SystemStatusResponse = {
  status: string;
  timestamp?: string;
  business_date?: string;
  businessDate?: string;
  system_timestamp?: string;
  systemTimestamp?: string;
  modules?: Record<string, string>;
  last_eod_run?: string;
  lastEodRun?: string;
  migration_head?: string;
  migrationHead?: string;
};

export type SystemCommandResponse = {
  status: string;
  message?: string;
  timestamp?: string;
  requested_at?: string;
  requestedAt?: string;
  components?: string[];
};

export const systemApi = {
  businessDate: (opts?: ApiOpts): Promise<BusinessDateResponse> =>
    apiClient.get<BusinessDateResponse>('/api/v1/system/business-date', opts),

  status: (opts?: ApiOpts): Promise<SystemStatusResponse> =>
    apiClient.get<SystemStatusResponse>('/api/v1/system/status', opts),

  reloadConfig: (opts?: ApiOpts): Promise<SystemCommandResponse> =>
    apiClient.post<SystemCommandResponse>('/api/v1/system/reload-config', {}, opts),

  rebuildProjections: (opts?: ApiOpts): Promise<SystemCommandResponse> =>
    apiClient.post<SystemCommandResponse>('/api/v1/system/rebuild-projections', {}, opts),
};
